import { useState } from 'react';

const useMenuMobile = () => {
    const [openMenuMobile, setOpenMenuMobile] = useState(false)

    const handleMenuMobile = () => {
        setOpenMenuMobile((toggleOpen) => !toggleOpen)
    }

    const closeMenuMobile = () => {
        setOpenMenuMobile(false)
    }

    return {
        openMenuMobile,
        handleMenuMobile,
        closeMenuMobile,
    }
}

export default useMenuMobile
